export const priceScreenState = {
    on: {
        BACK: "estimation",
        SET_PRODUCT_ID: {
            actions: "setCurrentProductIdStore",
        },
        SET_PRODUCT_TYPE: {
            actions: "setProductType",
        },
        SET_START_DATES: {
            actions: "setStartDates",
        },
    },
};
